function PeopleDetails() {
  return (
    <div></div>
  )
}

export default PeopleDetails;